import * as React from "react";
import {
  DataGrid,
  type DataGridProps,
  type GridColDef,
  type GridRowsProp,
  type GridValidRowModel,
} from "@mui/x-data-grid";
import { Box, useTheme } from "@mui/material";

type CustomDataGridProps = Omit<
  DataGridProps<GridValidRowModel>,
  "rows" | "columns"
> & {
  rows: GridRowsProp;
  columns: GridColDef[];
  height?: number | string;
  autoHeight?: boolean;
};

const CustomDataGrid: React.FC<CustomDataGridProps> = ({
  rows,
  columns,
  height = 500,
  autoHeight = false,
  rowHeight = 68,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: autoHeight ? "auto" : height,
        width: "100%",
        "& .MuiDataGrid-root": {
          border: "none",
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: theme.palette.background.default,
          fontWeight: "bold",
        },
        "& .MuiDataGrid-cell": {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        autoHeight={autoHeight}
        rowHeight={rowHeight}
        {...rest}
      />
    </Box>
  );
};

export default CustomDataGrid;
